export default __webpack_public_path__ + "static/media/human.2ef58533.svg";